import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import { useFeatures } from "components/FeatureFlag";
import Modal from "components/Modal";

function SkipAddUserModal({ loading, onAddUser, onClose }) {
  const addUserOnboardingFF = useFeatures("add-user-during-onboarding");

  return (
    <Modal
      data-test="skip-add-users-modal"
      size="small"
      isModalOpen
      onClose={onClose}
    >
      <Modal.Header onClose={onClose}>
        {addUserOnboardingFF?.skipAddUserModal?.title ||
          "Are You Sure You Want to Proceed Without Inviting?"}
      </Modal.Header>
      <Modal.Body>
        {addUserOnboardingFF?.skipAddUserModal?.body ||
          "Hi there! It looks like there are some users who can be invited. " +
            "Would you like to invite them now? Don't worry—you can always do " +
            "it later from the Settings page if you prefer."}
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="button"
          basic
          onClick={() => {
            onAddUser({ inviteNow: false });
          }}
          disabled={loading}
        >
          {addUserOnboardingFF?.skipAddUserModal?.cancelButton ||
            "No, I'll handle it later"}
        </Button>
        <Button
          primary
          onClick={() => {
            onAddUser({ inviteNow: true });
          }}
          loading={loading}
          disabled={loading}
        >
          {addUserOnboardingFF?.skipAddUserModal?.okButton ||
            "Yes, let's invite them"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

SkipAddUserModal.propTypes = {
  loading: PropTypes.bool,
  onAddUser: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

SkipAddUserModal.defaultProps = {
  loading: false,
};

export default SkipAddUserModal;
